import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 月例テストランキング取得
 */
export namespace ApiTaRe180 {
  // API Name
  export const name: string = 'ApiTaRe180'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/getMonthlyTestRank'

    export interface Request {
      query: {
        fiscalYear: number
        testMonth: number
        testCountPerMonth?: number
        subjectCode: string
        grade: number
        courseId: string
      }
    }

    export interface Response {
      results: {
        ranking: string
        score: string
        nickName: string
        schoolName: string
      }[]
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        results: [
          {
            ranking: '',
            score: '',
            nickName: '',
            schoolName: '',
          },
        ],
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
